/** @flow */
import Geolocation from 'common/domain/Geolocation';
import type { GeolocationData } from 'common/domain/Geolocation';

export type PlainGeolocationReach = {
  geolocation: GeolocationData;
  reach: number;
}

export function calculateTopNAsPercents(topN: number, reaches: GeolocationReach[]): GeolocationReach[] {
  if (reaches.length === 0) {
    return [];
  }

  const total = reaches.map(reach => reach.reach).reduce((a, b) => a + b);

  return reaches
    .sort(GeolocationReach.sortDesc)
    .map(({ geolocation, reach }) => new GeolocationReach(geolocation, reach / total))
    .slice(0, topN);
}

export default class GeolocationReach {
  geolocation: Geolocation;
  reach: number;

  constructor(geolocation: Geolocation, reach: number) {
    this.geolocation = geolocation;
    this.reach = reach;
  }

  getMapKey(): string {
    return this.geolocation.getUniqueId();
  }

  static sortDesc(a: GeolocationReach, b: GeolocationReach) {
    return b.reach - a.reach;
  }

  static parse(data: PlainGeolocationReach): GeolocationReach {
    return new GeolocationReach(Geolocation.parse(data.geolocation), data.reach);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/domain/GeolocationReach.js